/* global femcare, Swiper */

femcare.gallery.article = {
    init() {
        const galleries = document.querySelectorAll('.article-gallery--multislide');

        if (galleries.length) {
            galleries.forEach(gallery => {
                const swiperEl = gallery.querySelector('.article-gallery__content');
                const items = swiperEl?.querySelectorAll('.article-gallery__item') || [];

                if (items.length > 1) {
                    new Swiper(swiperEl, {
                        slidesPerView: 1,
                        spaceBetween: 15,
                        pagination: {
                            el: gallery.querySelector('.article-gallery__pagination'),
                            type: 'bullets',
                            bulletElement: 'button',
                            clickable: true,
                            bulletClass: 'article-gallery__page',
                            bulletActiveClass: 'article-gallery__page--active'
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 30,
                            }
                        }
                    });
                }
            });
        }
    }
};
